import React from 'react'
import { Button, VidyardPlayButton } from '@toasttab/shared/src/components'
import { VidyardVideoPlayerProps } from './VidyardVideo.d'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'

const VidyardVideoPlayer = ({
  vidyardId,
  display = 'thumbnail'
}: VidyardVideoPlayerProps) => {
  const { t } = useI18next()
  const handleClick = () => {
    if (typeof window !== 'undefined') {
      const vidyardEmbed = require('@vidyard/embed-code')
      let players = vidyardEmbed.api.getPlayersByUUID(vidyardId)
      players[0].showLightbox()
    }
  }

  return (
    <section className='otl-vidyard-player'>
      {display == 'playButton' && (
        <div className='mt-3'>
          <Button
            variation='secondary-otl'
            size='medium'
            classes='hover:border-otl-dark-blue hover:bg-otl-dark-blue'
            onClick={handleClick}
          >
            <span className='uppercase'>{t('Play Video')}</span>
          </Button>
        </div>
      )}
      {display == 'thumbnail' && (
        <div className='relative mt-5 mb-12 flex flex-wrap w-full'>
          <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20'>
            <VidyardPlayButton onClick={handleClick} />
          </div>
          <div className='mx-auto w-full overflow-hidden block h-auto relative text-center max-w-full'>
            <img
              className='vidyard-player-embed w-full m-auto block '
              src={`https://play.vidyard.com/${vidyardId}.jpg`}
              data-uuid={vidyardId}
              data-v='4'
              data-type='lightbox'
            />
          </div>
        </div>
      )}
    </section>
  )
}

export default VidyardVideoPlayer
